import { useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card"
import { Label } from "@/components/ui/label"
import { Input } from "@/components/ui/input"
import { Button } from "@/components/ui/button"
import { resetPassword } from "~/apis/passwords"
import routes from "~/routes"

export default function ResetPassword() {
  const { token } = useParams()
  const navigate = useNavigate()
  const [ password, setPassword ] = useState("")
  const [ passwordConfirmation, setPasswordConfirmation ] = useState("")
  const [ error, setError ] = useState(null)

  async function handleSubmit(event) {
    event.preventDefault()
    setError(null)

    try {
      await resetPassword(token, password, passwordConfirmation)
      navigate(routes.signIn)
    } catch (err) {
      setError(err.message)
    }
  }

  return (
    <div className="mx-auto mt-24 max-w-sm px-6">
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Update your password</CardTitle>
        </CardHeader>
        <CardContent>
          {error && <p className="mb-4 text-sm text-destructive">{error}</p>}

          <form onSubmit={handleSubmit} className="space-y-3">
            <div className="space-y-1.5">
              <Label htmlFor="password">New password</Label>
              <Input
                id="password"
                type="password"
                required
                autoComplete="new-password"
                maxLength={72}
                placeholder="Enter new password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
              />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password_confirmation">Confirm password</Label>
              <Input
                id="password_confirmation"
                type="password"
                required
                autoComplete="new-password"
                maxLength={72}
                placeholder="Repeat new password"
                value={passwordConfirmation}
                onChange={(event) => setPasswordConfirmation(event.target.value)}
              />
            </div>
            <Button type="submit" className="w-full">
              Save
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  )
}
